export default __webpack_public_path__ + "static/media/homepage-banner-image_default_20251205.adaad7c6.png";